// Fix to convert the theme config vars to kebab case
function convertCssVarsToKebabCase(themeConfig: ThemeConfig) {
  const convertedCssVars = Object.fromEntries(
    Object.entries(themeConfig.cssVariables || {}).map(([key, value]) => [useSnakeCase(key).replaceAll('_', '-'), value]),
  )
  return {
    ...themeConfig,
    // the fetch util automatically converts keys to camelcase, so we need to do the reverse here
    cssVariables: convertedCssVars,
  }
}

// Before initial page load:
// 1) Load the theme config from the center profile
// 2) Convert it to kebab case
// 3) Apply it
export default defineNuxtRouteMiddleware(async (to, from) => {
  if (import.meta.client) return

  // This should've been fetched by a previous middleware
  const { currentCenterProfile } = useCurrentCenter()

  if (!currentCenterProfile.value) {
    console.error('[load-center-theme] current center profile not found')
    return
  }

  // Preload and apply (partially) the theme config
  // Partially because the CSS vars are not applied yet (need to be implemented later)
  const { themeConfig } = useThemeConfig()
  if (currentCenterProfile.value?.themeConfig) {
    console.log('[load-center-theme] currentCenterProfile.value?.themeConfig', currentCenterProfile.value?.themeConfig)
    // If a theme is configured for the center, use that
    themeConfig.value = convertCssVarsToKebabCase(currentCenterProfile.value?.themeConfig)
  }
  else {
    console.log('[load-center-theme] no theme config found')
  }
  const { applyThemeConfig } = useTheme()
  applyThemeConfig(themeConfig.value)
})
